<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h1>Record fuel deliveries</h1>
      </v-col>
    </v-row>
    <v-form>
      <v-row>
        <v-col class="col-3">
          <v-date-picker
            label="Delivery date"
            v-model="delivery.delivery_date"
          ></v-date-picker>
        </v-col>
        <v-col class="col-3">
          <v-text-field label="Quantity (litres)" v-model="delivery.quantity_litres"></v-text-field>
          <v-text-field label="Reference" v-model="delivery.reference"></v-text-field>
        </v-col>
        <v-col class="col-3">
          <v-text-field
            label="Price (per litre)"
            v-model="delivery.price_per_litre"
            type="number"
            min="0"
            step="0.01"></v-text-field>
            <v-btn class="mt-3" block @click="saveDelivery">Save</v-btn>
        </v-col>
        <v-col class="col-3">
          <v-text-field label="Supplier" v-model="delivery.supplier"></v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
  
<script>
import axios from '../../../axios';

export default {
  name: 'AdminColours',
  computed: {
    token() {
      return this.$store.state.token;
    },
    userid() {
      return this.$store.state.userid;
    },
  },
  data() {
    return {
      delivery: {
        delivery_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },
    };
  },
  methods: {
    saveDelivery() {
      axios.post(`/fuelDeliveries/create/${this.userid}.json?token=${this.token}`, this.delivery)
        .then(() => {
          this.$router.push('/admin/fuel/index')
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
  